// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1eIGG","notes":"Notes_notes__3hIxM"};